<style scoped>
.faucet-position-block {
    padding: 30px 0 0 75px;
}

.faucet-position-btn-block {
    padding-top: 25px;
}

.faucet-position-btn-block .error {
    color: brown;
}

.connected-msg {
    position: fixed;
    width: 100%;
    height: 90px;
    bottom: 0;
    left: 0;
    text-align: center;
    background-color: rgb(218, 87, 120);
    padding: 10px;
    font-size: 25px;
}

.update-fireware-modal-info {
    text-align: center;
}

.update-fireware-modal-info .button-block {
    padding: 20px;
}
</style>

<template>
<div class="col-12 setting-faucet-page">
    <div class="loader loader-in-group-settings" v-if="loader_block">
        <loader-component></loader-component>
    </div>
    <div v-if="!loader_block">
        <div class="offset-md-3 col-md-6">
            <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
        </div>
        <div class="col-12 row input-setting-block">
            <div class="offset-1 col-1 elips"></div>
            <div class="col-2 item-name">
                Имя
            </div>
            <div class="col-7">
                <input v-bind:class="{fail: faucet_name_msg}" type="text" v-model="faucet_name">
    </div>
                <div v-if="faucet_name_msg" class="offset-4 col-7 after-input-msg">
                    <p>{{faucet_name_msg}}</p>
                </div>
                <div class="offset-4 col-7 text-info-after-input-block">
                    <p>Отображаться в списке кранов</p>
                </div>
            </div>
            <div class="col-12 row input-setting-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                    Уникальный идентификатор
                </div>
                <div class="col-7 faucet-serial-number">
                    <h3>ID {{serial_number}}</h3>
                </div>
            </div>
            <div class="col-12 row input-setting-block battery-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                    Питание крана
                </div>
                <div class="col-2">
                    <div class="icon" :class="getPowerIconClass"></div>
                </div>
                <div class="col-5">
                    <p>Питание крана: от батарей или внешнего источника </p>
                </div>
            </div>
            <div class="col-12 row input-setting-block wi-fi-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                    Связь
                </div>
                <div class="col-2">
                    <div class="icon" :class="getNetworkIconClass"></div>
                </div>
                <div class="col-5">
                    <p class="network-name">{{faucet_network}}</p>
                </div>
                <div class="offset-4 col-7 text-info-after-input-block">
                    <p>Качество связи и доступ в интернет</p>
                </div>
            </div>
            <div class="col-12 row input-setting-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                    Состояние крана
                </div>
                <div class="col-7 row">
                    <div class="col-6 faucet-position-block" :class="getPositionColor">
                        <h4>{{getPositionName}}</h4>
                    </div>
                    <div class="col-6 faucet-position-btn-block" v-if="select_mode.type == 'manual' && position == 'close'">
                        <button class="btn btn-outline-primary" @click="changePosition(1)">Открыть</button>
                    </div>
                    <div class="col-6 faucet-position-btn-block" v-if="select_mode.type == 'manual' && position == 'open'">
                        <button class="btn btn-outline-info" @click="changePosition(0)">Закрыть</button>
                    </div>
                </div>
                <div class="offset-4 col-7 text-info-after-input-block">
                    <p>Состояние крана: ОТКРЫТ или ЗАКРЫТ, ОТКРЫВАЕТСЯ или ЗАКРЫВАЕТСЯ. Если кран ОШИБКА или НЕИЗВЕСТНО, проверьте, исправен ли он.</p>
                </div>
            </div>
            <scouring-component :id_faucet="id_faucet"></scouring-component>
            <div class="col-12 row input-setting-block firmware-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                    Версия прошивки крана
                </div>
                <div class="col-5 firmware-version-text">
                    <p>{{firmware_version}}</p>
                </div>
                <div class="col-2 firmware-version-text">
                    <a v-b-modal.modal_update_firmware class="aquazor-btn-small" v-if="connected">Обновить</a>
                </div>
            </div>
            <div class="col-12 row input-setting-block mode-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                    Режим работы
                </div>
                <div class="col-7 aquazor-selector">
                    <v-select :clearable="false" label="name" :options="modes" v-model="select_mode" :onChange="saveMode">
                    </v-select>
                </div>
                <div class="offset-4 col-7 text-info-after-input-block">
                    <p v-if="select_mode.type == 'auto'">АВТО: закрывание крана при срабатывании любого датчика и переход в ручной режим</p>
                    <p v-if="select_mode.type == 'manual'">РУЧНОЙ: управление краном вручную. Датчики игнорируются.</p>
                    <p v-if="select_mode.type == 'schedule'">РАСПИСАНИЕ: открывание и закрывание по расписанию. При срабатывании датчиков краны закрываются и переходят в ручной режим.</p>
                </div>
            </div>
            <div class="end-line-block"></div>
            <manual-mode-component v-if="select_mode.type == 'manual'" :id_faucet="id_faucet"></manual-mode-component>
            <schedule-mode-component v-if="select_mode.type == 'schedule'" :id_faucet="id_faucet"></schedule-mode-component>
        </div>
        <div class="connected-msg" v-if="!connected">
            <p>Кран не на связи</p>
        </div>
        <b-modal id="modal_update_firmware" size="md" title="" :hide-footer="true" v-model="show_update_firmware_modal">
            <div class="update-fireware-modal-info">
                <h2>Внимание! Небезопасное действие!</h2>
                <p>Перед началом обновления ознакомьтесь с информацией о новой прошивке.</p>
                <p>Убедитесь что заряда батарей не менее 50% и адаптер питания подключен.</p>
                <p>Находитесь возле крана для наблюдения за процессом обновления.</p>
                <div class="button-block">
                    <a class="aquazor-btn" @click="updateFirmware()">Обновить</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import msg from './elements/msg.vue'
import ManualMode from './elements/manual-mode.vue'
import ScheduleMode from './elements/schedule-mode.vue'
import scouring from './elements/scouring.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'

import {
    store
} from '@/store'

export default {
    created() {
        GetFaucetSettings(this)
        get_faucet_info(this)
        this.setinterval_faucet_data = setInterval(() => {
            get_faucet_info(this)
        }, config.UPDATE_PERIOD);
    },
    components: {
        'v-select': vSelect,
        'loader-component': loader,
        'msg-component': msg,
        'manual-mode-component': ManualMode,
        'scouring-component': scouring,
        'schedule-mode-component': ScheduleMode
    },
    data() {
        return {
            msg_general: {
                type: 'hidden',
                text: ''
            },
            connected: true,
            faucet_name: null,
            loader_block: true,
            faucet_name_msg: '',
            serial_number: '',
            id_faucet: this.$route.params.id_faucet,
            position: 'unknown',
            power: 0,
            faucet_network: null,
            faucet_network_rssi: null,
            select_mode: null,
            select_mode_type: null,
            modes: [{
                    type: "manual",
                    name: "РУЧНОЙ"
                },
                {
                    type: "auto",
                    name: "АВТО"
                },
                {
                    type: "schedule",
                    name: "РАСПИСАНИЕ"
                }
            ],
            setinterval_faucet_data: null,
            firmware_version: '-',
            show_update_firmware_modal: false
        }
    },
    watch: {
        faucet_name: function (this_faucet_name, old_faucet_name) {
            if (old_faucet_name != null && this_faucet_name != old_faucet_name) {
                setTimeout(() => {
                    if (this_faucet_name == this.faucet_name) {
                        saveName(this_faucet_name, this)
                    }
                }, 1000)
            }
        },
        history_checked: function (this_history_checked, old_history_checked) {
            if (old_history_checked != null && this_history_checked != old_history_checked) {
                saveAddHistory(this_history_checked, this)
            }
        },
        // select_mode: function (this_mode, old_mode) {
        //     if (old_mode != null && this_mode != old_mode) {
        //         saveMode(this_mode, this)
        //     }
        // }
    },
    computed: {
        getPositionName: function () {
            var name = 'Неизвестно1'
            if (this.position == 'unknown') {
                name = 'НЕИЗВЕСТНО'
            } else if (this.position == 'open') {
                name = 'ОТКРЫТ'
            } else if (this.position == 'open_process') {
                name = 'ОТКРЫВАЕТСЯ'
            } else if (this.position == 'close') {
                name = 'ЗАКРЫТ'
            } else if (this.position == 'close_process') {
                name = 'ЗАКРЫВАЕТСЯ'
            } else if (this.position == 'error') {
                name = 'ОШИБКА'
            }
            return name
        },
        getPositionColor: function () {
            if (this.position == 'unknown' || this.position == 'error') {
                return 'error'
            } else {
                return ''
            }
        },
        getPowerIconClass: function () {
            var power_class = 'battery-cable-power'
            if (this.power > 0 && this.power <= 4) {
                power_class = 'battery-' + this.power
            }
            return power_class
        },
        // Сила сигнала 10 - нет сети, 11 - сеть 1 деление, 12 - сеть 2 деления, 13 - сеть 3 деления
        getNetworkIconClass: function () {
            var network_class = 'no-wifi'
            if (this.faucet_network_rssi == 11) {
                network_class = 'wifi-2'
            } else if (this.faucet_network_rssi == 12) {
                network_class = 'wifi-1'
            } else if (this.faucet_network_rssi == 13) {
                network_class = 'wifi'
            }
            return network_class
        }
    },
    methods: {
        changePosition: function (position) {
            changePosition(position, this)
        },
        saveMode: function (val) {
            this.select_mode = val
            if (this.select_mode_type != this.select_mode.type) {
                saveMode(this.select_mode, this)
            }
        },
        updateFirmware: function () {
            updateFirmware(this)
        }
    },
    destroyed() {
        clearInterval(this.setinterval_faucet_data)
    },
}

function GetFaucetSettings(vue_obj) {
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('id_group', vue_obj.$route.params.id_group)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/faucet_settings',
            data: post_data
        })
        .then(function (response) {
            if (!!response.data.name) {
                vue_obj.faucet_name = response.data.name
            }
            if (!!response.data.firmware_version) {
                vue_obj.firmware_version = response.data.firmware_version
            }
            if (!!response.data.device_number) {
                var serial_number = response.data.device_number.split("-").join("")
                serial_number = serial_number.toUpperCase()
                if (serial_number.length > 0) {
                    serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
                }
                vue_obj.serial_number = serial_number
            }
            if (!!response.data.position) {
                vue_obj.position = response.data.position
            }
            if (typeof response.data.power !== 'undefined') {
                vue_obj.power = response.data.power
            }
            if (!!response.data.faucet_network) {
                vue_obj.faucet_network = response.data.faucet_network
            }
            if (!!response.data.faucet_network_rssi) {
                vue_obj.faucet_network_rssi = response.data.faucet_network_rssi
            }
            if (typeof response.data.connect !== 'undefined') {
                vue_obj.connected = response.data.connect
            }
            if (!!response.data.mode) {
                vue_obj.select_mode_type = response.data.mode
                vue_obj.modes.forEach(mode_element => {
                    if (response.data.mode == mode_element.type) {
                        vue_obj.select_mode = mode_element
                    }
                });
            }
            vue_obj.loader_block = false
            get_faucet_position_start(vue_obj)
        })
        .catch(function (error) {
            console.log(error.response.data)
        })
}

function saveName(new_name, vue_obj) {
    vue_obj.msg_general = {
        type: 'hidden',
        text: ''
    }
    vue_obj.faucet_name_msg = ''
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('name', new_name)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_faucet_name',
            data: post_data
        })
        .then(function (request) {
            console.log(request)
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                vue_obj.faucet_name_msg = error.response.data.exception
            }
        })
}

function saveAddHistory(new_add_history_status, vue_obj) {
    vue_obj.msg_general = {
        type: 'hidden',
        text: ''
    }
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('history_status', new_add_history_status)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_faucet_history_status',
            data: post_data
        })
        .then(function (request) {
            console.log(request)
        })
        .catch(function (error) {
            console.log(error)
        })
}

function changePosition(new_position, vue_obj) {
    vue_obj.msg_general = {
        type: 'hidden',
        text: ''
    }
    vue_obj.name_msg = ''
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('position', new_position)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_faucet_position',
            data: post_data
        })
        .then(function (request) {
            get_faucet_statuses(vue_obj)
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                vue_obj.faucet_name_msg = error.response.data.exception
            }
        })
}

function get_faucet_info(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_faucet', vue_obj.id_faucet)
        post_data.set('id_group', vue_obj.$store.getters.id_group)

        axios({
                method: 'POST',
                url: config.API_HOST + '/faucets/faucet_settings',
                data: post_data
            })
            .then(function (response) {
                if (!!response.data.position) {
                    vue_obj.position = response.data.position
                }
                if (!!response.data.firmware_version) {
                    vue_obj.firmware_version = response.data.firmware_version
                }
                if (!!response.data.faucet_network) {
                    vue_obj.faucet_network = response.data.faucet_network
                }
                if (!!response.data.faucet_network_rssi) {
                    vue_obj.faucet_network_rssi = response.data.faucet_network_rssi
                }
                if (typeof response.data.connect !== 'undefined') {
                    vue_obj.connected = response.data.connect
                }
                if (!!response.data.mode) {
                    vue_obj.select_mode_type = response.data.mode
                    vue_obj.modes.forEach(mode_element => {
                        if (response.data.mode == mode_element.type) {
                            vue_obj.select_mode = mode_element
                        }
                    });
                }
            })
            .catch(function (error) {
                console.log(error.response.data)
            })
    }
}

function saveMode(new_mode, vue_obj) {
    vue_obj.msg_general = {
        type: 'hidden',
        text: ''
    }
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('mode', new_mode.type)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_faucet_mode',
            data: post_data
        })
        .then(function (request) {
            console.log(request)
            if (new_mode.type == "auto") {
                note({
                    content: 'Внимание! Вы перешли в авторежим и ваш кран будет открыт.',
                    type: 'info',
                    time: 15
                })
            }
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                vue_obj.faucet_name_msg = error.response.data.exception
            }
        })
}

function updateFirmware(vue_obj) {
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_faucet', vue_obj.id_faucet)
    post_data.set('id_group', vue_obj.$store.getters.id_group)

    axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/update_faucet_firmware',
            data: post_data
        })
        .then(function (request) {
            vue_obj.show_update_firmware_modal = false
            note({
                content: 'Команда на обновление принята',
                type: 'info',
                time: 15
            })
        })
        .catch(function (error) {
            if (!!error.response.data.exception) {
                vue_obj.faucet_name_msg = error.response.data.exception
                note({
                    content: error.response.data.exception,
                    type: 'error',
                    time: 20
                })
            }
        })
}
</script>



// WEBPACK FOOTER //
// src/components/faucet-settings.vue